import * as React from "react";
const SvgServingTray = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12.75 2.75a.75.75 0 0 0-1.5 0v1.28a9.001 9.001 0 0 0-8.236 8.47H2.75a.75.75 0 0 0 0 1.5h3.966c-.086.336-.08.706.05 1.078l1.188 3.416-.909 2.497a.75.75 0 0 0 .705 1.007h3.75a.75.75 0 0 0 .712-.513l.689-2.065 3.998-3.69a1.704 1.704 0 0 0 .508-1.73h3.843a.75.75 0 0 0 0-1.5h-.264a9.001 9.001 0 0 0-8.236-8.47V2.75ZM12.573 14l-1.566.783-.522-.783h2.088ZM12 5.5a7.5 7.5 0 0 1 7.484 7H4.516A7.5 7.5 0 0 1 12 5.5Zm-3.817 9.086a.376.376 0 0 1 .668-.333l1.275 1.913a.75.75 0 0 0 .96.255l4.21-2.105c.12-.06.248-.1.382-.12a.25.25 0 0 1 .204.431l-3.879 3.58-2.694-.385-1.126-3.236Zm1.064 4.742 2.007.287-.294.883H8.82l.426-1.17Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgServingTray;
